import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Modal, Form, Input, Button,
} from "antd";
import { editSequenceData } from "../../../../../actions/chemistry";
import { getUser } from "../../../../../utils/helpers";
import "./EditSequence.css";

const fileNameValidator = (_, value) => {
  // Windows: cannot contain \ / : * ? " < > |, Mac: cannot contain :
  // We'll disallow all \ / : * ? " < > | (covers both)
  if (!value || value.trim() === "") {
    return Promise.resolve();
  }
  // Regex: match any of the forbidden characters
  const forbidden = /[\\/:*?"<>|]/;
  if (forbidden.test(value)) {
    return Promise.reject(
      new Error(
        "Instrument Method cannot contain \\ / : * ? \" < > |",
      ),
    );
  }
  return Promise.resolve();
};

const EditSequence = ({
  open, onCancel, record, formInputs,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user = getUser();

  useEffect(() => {
    if (open) {
      // initialize form fields
      const formFields = {};
      formInputs.forEach((inputObj) => {
        const { key } = inputObj;
        formFields[key] = record ? record[key] : "";
      });
      form.setFieldsValue(formFields);
    }
  }, [open, record, form, formInputs]);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const formValue = await form.validateFields();
      if (formValue.instrument_method === record.instrument_method) { // If the instrument method value hasn't change, then close the popup
        setLoading(false);
        onCancel(false);
        return;
      }
      const payload = {
        pk: record.pk,
        user_id: user.id,
        instrument_method: formValue.instrument_method,
      };
      const { success, message } = await editSequenceData(payload);

      if (success) {
        toast.success(message);
        onCancel(true);
      } else {
        toast.error(message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Modal
      centered
      title={record ? "Edit Sequence" : "Create Sequence"}
      open={open}
      onCancel={() => onCancel(false)}
      closeIcon={null}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={() => onCancel(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={onSubmit}
        >
          {record ? "Save" : "Create"}
        </Button>,
      ]}
      okText={record ? "Save" : "Create"}
      className="SequenceEditModal"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={() => {
          onCancel();
        }}
        requiredMark={false}
        className="EditSequenceForm"
      >
        {formInputs.map((inputObj) => {
          const { title, key } = inputObj;
          const isEdit = record;
          // Only set the fields to required if it's a Create action
          const rules = [{ required: !isEdit, message: `${title} is required` }];
          let childNode = <Input disabled={isEdit} />;
          // Always set the instrument_method to required
          // Set the file name validator
          if (key === "instrument_method") {
            rules[0].required = true;
            rules.push({ validator: fileNameValidator });
            childNode = <Input />;
          }
          return (
            <Form.Item
              key={key}
              label={title}
              name={key}
              rules={rules}
            >
              {childNode}
            </Form.Item>
          );
        })}
      </Form>
    </Modal>
  );
};

export default EditSequence;
